module.exports = __webpack_public_path__ + "img/WCAChinaGlobal.bd2cf083.png";